import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchError } from './commonSlice';

const initialState = {
  list: [],
  perPage: '',
  total: '',
  loading: false,
  errorMessage: '',
};

export const getStoreList = createAsyncThunk('get-store-list', async ({ id, data }, { dispatch }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}admin/store/list?userId=${id}`, { params: data });
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const deleteStore = createAsyncThunk('delete-store', async (id, { dispatch }) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}admin/store/${id}`);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const storeCreate = createAsyncThunk('store-create', async ({ data }, { dispatch }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}admin/store`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const storeUpdate = createAsyncThunk('store-update', async ({ id, data }, { dispatch }) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}admin/store/${id}`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const storeStatusUpdate = createAsyncThunk('store-status-update', async ({ id, data }, { dispatch }) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}admin/store/status/${id}`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStoreList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStoreList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.store_list;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
        state.errorMessage = '';
      })
      .addCase(getStoreList.rejected, (state, action) => {
        state.loading = false;
        state.list = '';
        state.perPage = '';
        state.total = '';
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(storeUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(storeUpdate.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(storeUpdate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(storeCreate.pending, (state) => {
        state.loading = true;
      })
      .addCase(storeCreate.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(storeCreate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(deleteStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteStore.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(deleteStore.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(storeStatusUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(storeStatusUpdate.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(storeStatusUpdate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });
  },
});

export default userSlice.reducer;
